// Fetch list

export const FETCH = 'invoiceItemTypes.FETCH'
export const FETCH_STARTED = 'invoiceItemTypes.FETCH_STARTED'
export const FETCH_FULFILLED = 'invoiceItemTypes.FETCH_FULFILLED'
export const FETCH_REJECTED = 'invoiceItemTypes.FETCH_REJECTED'
export const FETCH_CANCELLED = 'invoiceItemTypes.FETCH_CANCELLED'

export const SORTING_CHANGED = 'invoiceItemTypes.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'invoiceItemTypes.FETCH_ONE'
export const FETCH_ONE_STARTED = 'invoiceItemTypes.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'invoiceItemTypes.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'invoiceItemTypes.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'invoiceItemTypes.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'invoiceItemTypes.SAVE'
export const SAVE_STARTED = 'invoiceItemTypes.SAVE_STARTED'
export const SAVE_FULFILLED = 'invoiceItemTypes.SAVE_FULFILLED'
export const SAVE_REJECTED = 'invoiceItemTypes.SAVE_REJECTED'
export const SAVE_CANCELLED = 'invoiceItemTypes.SAVE_CANCELLED'

// Delete

export const DELETE = 'invoiceItemTypes.DELETE'
export const DELETE_STARTED = 'invoiceItemTypes.DELETE_STARTED'
export const DELETE_FULFILLED = 'invoiceItemTypes.DELETE_FULFILLED'
export const DELETE_REJECTED = 'invoiceItemTypes.DELETE_REJECTED'
export const DELETE_CANCELLED = 'invoiceItemTypes.DELETE_CANCELLED'

// Export

export const EXPORT = 'invoiceItemTypes.EXPORT'
export const EXPORT_FULFILLED = 'invoiceItemTypes.EXPORT_FULFILLED'
